export default __webpack_public_path__ + "static/Kepler-Track-credit-staggnz-90bed7bb9fc92992e39d29f4a900f963.jpg";